<template>
  <div id="SysLoginUserList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="search">
      <div class="searchItem">
        <el-input class="eb-input" v-model="searchKey" placeholder="请输入搜索内容" v-on:input="change"></el-input>
      </div>
    </div>
    <div class="table eb-table">
      <el-table :data.sync="newPageData" tooltip-effect="dark" style="width: 100%">
        <el-table-column prop='trueName' label="真实姓名" sortable width="100"></el-table-column>
        <el-table-column prop='userPhone' label="手机号" sortable width="100"></el-table-column>
        <el-table-column prop='orgName' label="机构名" sortable min-width="130"></el-table-column>
        <el-table-column prop='roleName' label="角色名称" sortable width="120"></el-table-column>
        <el-table-column prop='ipAddress' label="登录IP" sortable width="140"></el-table-column>
        <el-table-column prop='browser' label="浏览器" sortable width="160"></el-table-column>
        <el-table-column prop='os' label="操作系统" sortable width="160"></el-table-column>
        <el-table-column prop='lastAccessTime' label="最后一次操作时间" sortable>
          <template slot-scope="scope">
            {{lastAccessTime(scope.row.lastAccessTime)}}
          </template>
        </el-table-column>
      </el-table>
      <eb-pagination v-if="pageParams.totalCount" @current-change="handleCurrentChange" :current-page.sync="pageParams.currPage" :total="pageParams.totalCount" :page-size="pageParams.pageSize" />
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { getLoginUsers } from '@/services/system-service';
import { clone } from 'lodash';
export default {
  name: 'SysLoginUserList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPagination
  },
  data() {
    return {
      loading: true,
      pageData: [],
      tableData: [],
      pageParams: {
        currPage: 1,
        pageSize: 10,
        totalCount: null,
        totalPage: null
      },
      searchKey: ''
    };
  },
  created() {
    this.initLoginUsers();
  },
  computed: {
    newPageData: function() {
      return this.pageData.slice(
        (this.pageParams.currPage - 1) * this.pageParams.pageSize,
        this.pageParams.currPage * this.pageParams.pageSize
      );
    },
    totalPageCount: function() {
      return (
        parseInt(this.pageParams.totalCount / this.pageParams.pageSize) +
        (this.pageParams.totalCount % this.pageParams.pageSize === 0 ? 0 : 1)
      );
    }
  },
  methods: {
    async initLoginUsers() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getLoginUsers();
        if (data.returnCode === '01') {
          this.pageData = data.loginUserList;
          this.tableData = data.loginUserList;
          this.pageParams.totalCount = data.loginUserList.length;
          this.pageParams.totalPage = this.totalPageCount;
        } else {
          this.$message.error('查询查询当前登录用户失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },

    handleCurrentChange(val) {
      this.pageParams.currPage = val;
    },
    change(value) {
      let searchData = clone(this.tableData);
      if (value === '') {
        this.pageData = searchData;
        this.pageParams.totalCount = searchData.length;
        this.pageParams.totalPage = this.totalPageCount;
        return false;
      }
      let data = [];
      searchData.forEach(item => {
        if (
          item.trueName.indexOf(value) !== -1 ||
          item.userPhone.indexOf(value) !== -1 ||
          item.departName.indexOf(value) !== -1 ||
          item.roleName.indexOf(value) !== -1
        ) {
          data.push(item);
        }
      });
      this.pageParams.totalCount = data.length;
      this.pageParams.totalPage = this.totalPageCount;
      this.pageData = data;
    },
    lastAccessTime(time) {
      return this.$options.filters['dateTimeStandardFormat'](time);
    }
  }
};
</script>
<style lang="less" scoped>
#SysLoginUserList {
  .search {
    width: 99%;
    height: 40px;
    margin-top: 20px;
    .searchItem {
      width: 30%;
      float: right;
      input {
        width: 260px;
      }
    }
  }
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
</style>
